import { ChangeEvent } from 'react';
import { CustomCellEditorProps } from 'ag-grid-react';
import { Button } from '@mui/material';

export const ImageUploadEditor = ({ onValueChange, stopEditing }: CustomCellEditorProps) => {
  const handleFileUpload = (e: ChangeEvent<HTMLInputElement>) => {
    onValueChange(e.target.files?.[0] ?? null);
    stopEditing(true);
  };

  return (
    <Button variant="outlined" component="label">
      Upload
      <input type="file" hidden onChange={handleFileUpload} />
    </Button>
  );
};
